module.exports = __webpack_public_path__ + "static/media/Office-Intern thumbnail.e54ad00f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Office-Intern thumbnail.png
// module id = 123
// module chunks = 0